import { FuelScreen } from '@felix/ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officeFuelSource } from '../fuel-source.js';

/**
 * Yakıt Yönetimi (ortak ekran; ADR 0117 §14): yedi sekme `/fuel/<sekme>`. Ofiste tanklar gemi
 * seçimiyle salt okunur; yakıt ana kaydı ofiste yazılır.
 */
export function FuelPage() {
  const { t } = useTranslation();
  const source = useMemo(() => officeFuelSource(), []);
  return (
    <Shell title={t('fuel.title')}>
      <FuelScreen source={source} />
    </Shell>
  );
}
